import { useState, useEffect } from "react";
import BootstrapTable from "react-bootstrap-table-next";
import { Button, Modal, ModalHeader, ModalBody, ModalFooter, Spinner } from "reactstrap";
import { toast } from "react-toastify";
import { useSelector } from 'react-redux';

import { useGetRequestQuery } from "../../../../Hooks/useGetRequestQuery";
import { useMutationRequestQuery } from "../../../../Hooks/useMutationRequestQuery";
import { getClientListService, deleteClientService, getClientAuthTokenService } from "../../../../Services/CRMAdminServices/CRMClientService";
import { useDispatch } from "react-redux";
import { setUserData } from "../../../../ReduxToolkit/Reducers/AuthSlice";
import { jwtDecode } from "jwt-decode";
import html2canvas from 'html2canvas';
import jsPDF from 'jspdf';
import { AssetsHTML,ExpenseDetailsHTMLtest, AssetsNonPropertyHTML, ClientOneHTML, ClientTwoHTML, DependentsHTML, ExpenseDetailsHTML, ExpenseDetailsHTML2, LiabilitiesHTML, VehicleAssetsHTML, AssetsNonPropertyHTML2  } from "../../Public/Form/BusinessWizard/BusinessTabContent/FactFindPdf";
import { RootState } from "../../../../ReduxToolkit/Store";
import api from "../../../../Hooks/axiosApi";

const CRMClientList = () => {
    const [clients, setClients] = useState([]);
    const [deleteModal, setDeleteModal] = useState(false);
    const [selectedClientId, setSelectedClientId] = useState<number | null>(null);
    const [loading, setLoading] = useState<boolean>(false);
    const [loadingClientId, setLoadingClientId] = useState<number | null>(null);
    const [file, setFile] = useState<any>(null)
    const factFind = useSelector((state: RootState) => state.factFind);

    const dispatch = useDispatch();

    const { data: clientsData, isLoading, isError, refetch } = useGetRequestQuery(
        ["getClients"],
        getClientListService,
        { enabled: true }
    );

    useEffect(() => {
        if (clientsData && !isError && !isLoading) {
            setClients(clientsData?.data);
        }
    }, [clientsData, isError, isLoading]);

    const { mutate: deleteClient, isPending: isDeleting } = useMutationRequestQuery(
        "deleteClientService",
        deleteClientService,
        {
            onSuccess: () => {
                toast.success("Client deleted successfully.");
                setDeleteModal(false);
                refetch()
            },
            onError: () => {
                toast.error("Failed to delete client.");
                setDeleteModal(false);
            },
        }
    );

    const confirmDelete = (id: number) => {
        setSelectedClientId(id);
        setDeleteModal(true);
    };

    const handleDeleteClick = () => {
        if (selectedClientId) {
            deleteClient(selectedClientId);
        }
    }

    const handleViewClient = async (userID: number) => {
        try {
            const response = await getClientAuthTokenService(userID);
            const { token } = response.data;

            if (token) {
                const decodedToken: any = jwtDecode(token);
                const sessionTime = decodedToken?.exp * 1000;
                localStorage.setItem("token", token);
                localStorage.setItem("policyAgree", "true");
                localStorage.setItem("sessionTime", sessionTime.toString());

                dispatch(setUserData({
                    nameidentifier: decodedToken["http://schemas.xmlsoap.org/ws/2005/05/identity/claims/nameidentifier"],
                    sub: decodedToken["sub"],
                    email: decodedToken["email"],
                    jti: decodedToken["jti"],
                    ContactNo: decodedToken["ContactNo"],
                    token: token,
                }));
                window.open("/MMPDashboard", "_blank");
            } else {
                toast.error("Login failed due to server error.");
            }
        } catch (error) {
            toast.error("An error occurred while fetching client token.");
        }
    };

    const getFactFindDetails = async (clientId: number) => {
        try {
            // Fetch all required data in parallel
            const [
                clientResponse,
                assetsResponse,
                nonPropertyResponse,
                vehicleAssetsResponse,
                liabilitiesResponse,
                expensesResponse,
                mppexpenseclients,
                Clientnonpropertydetails
            ] = await Promise.all([
                api.get(`/api/ClientFactFindPublic/Getfactfindclientdetailsbyid/${clientId}`),
                api.get(`/api/ClientFactFindPublic/GetAssetsPropertyByClientId/${clientId}`),
                api.get(`/api/ClientFactFindPublic/GetByAllClientLiabilitiesClientId/${clientId}`),
                api.get(`/api/ClientFactFindPublic/GetClientVehicleAssetsByClientId/${clientId}`),
                api.get(`/api/ClientFactFindPublic/GetByAllClientLiabilitiesClientId/${clientId}`),
                api.get(`/api/ClientFactFindPublic/GetfactClientExpensesbyid/${clientId}`),
                api.get(`/api/MppClient/GetGetClientMMPIncomeExpenseDetailsByClientId/${clientId}`),
                api.get(`/api/MppClient/GetAssetsAndLiabilitiesByClientId/${clientId}`)
            ]);

            // Combine all the data
            return {
                ...clientResponse.data,
                assetsProperty: assetsResponse.data,
                assetsNonProperty: nonPropertyResponse.data,
                assetsVehicles: vehicleAssetsResponse.data,
                liabilities: liabilitiesResponse.data,
                expenses: expensesResponse.data,
                mppexpenseclients: mppexpenseclients.data,
                Clientnonpropertydetails: Clientnonpropertydetails.data
            };
        } catch (error) {
            console.error("Error fetching fact find details:", error);
            toast.error("Failed to fetch client details");
            return null;
        }

    };

    const handleDownloadPDF = async (client: any) => {
        try {
            setLoading(true);
            setLoadingClientId(client.clientId);

            // Fetch fact find details
            const factFindDetails = await getFactFindDetails(client.clientId);
            console.log('test',factFindDetails.mppexpenseclients);
            if (!factFindDetails) {
                setLoading(false);
                setLoadingClientId(null);
                return;
            }

            // Show loading state while generating PDF
            toast.info("Generating PDF, please wait...");

            const doc = new jsPDF("p", "mm", "a4");
            const pageWidth = 210;
            const pageHeight = 297;

            const htmlSections = [
                { name: "Client One", html: ClientOneHTML(factFindDetails) },
                { name: "Client Two", html: ClientTwoHTML(factFindDetails) },
                { name: "Dependents", html: DependentsHTML(factFindDetails) },
                { name: "Assets", html: AssetsHTML(factFindDetails.assetsProperty) },
                { name: "Assets Non-Property", html: AssetsNonPropertyHTML2(factFindDetails.Clientnonpropertydetails) },
                { name: "Vehicle Assets", html: VehicleAssetsHTML(factFindDetails.assetsVehicles) },
                { name: "Liabilities", html: LiabilitiesHTML(factFindDetails.liabilities) },
                // { name: "Expense Details", html: ExpenseDetailsHTML(factFindDetails.expenses) },
                { name: "Expense Details", html: ExpenseDetailsHTMLtest(factFindDetails.mppexpenseclients) },
                // { name: "", html: ExpenseDetailsHTML2(factFindDetails.expenses) },
            ];
 
            for (let i = 0; i < htmlSections.length; i++) {
                const { name, html } = htmlSections[i];
                const container = document.createElement("div");

                container.style.width = "794px";
                container.style.position = "absolute";
                container.style.left = "-9999px";
                container.innerHTML = html;
                document.body.appendChild(container);

                try {
                    const canvas = await html2canvas(container, { scale: 1.5 });
                    const imgData = canvas.toDataURL("image/jpeg", 0.8);

                    let imgWidth = pageWidth;
                    let imgHeight = (canvas.height * imgWidth) / canvas.width;

                    if (imgHeight > pageHeight) {
                        imgHeight = pageHeight;
                    }

                    if (i !== 0) doc.addPage();
                    doc.addImage(imgData, "JPEG", 0, 0, imgWidth, imgHeight);
                } catch (error) {
                    console.error(`Error rendering section "${name}":`, error);
                } finally {
                    document.body.removeChild(container);
                }
            }

            // Save the PDF
            doc.save(`Client_${client.client1LastName}_${client.client1FirstName}_Details.pdf`);
            toast.success("PDF downloaded successfully!");
        } catch (error) {
            console.error("Error generating PDF:", error);
            toast.error("Failed to generate PDF");
        } finally {
            setLoading(false);
            setLoadingClientId(null);
        }
    };

    const clientColumns = [
        {
            dataField: "actions",
            text: "Action",
            formatter: (_: any, row: any) => (
                <div className="d-flex align-items-center">
                    <ul className="action simple-list d-flex flex-row mb-0">
                        <li style={{ cursor: "pointer" }} className="view">
                            <a onClick={() => handleViewClient(row.clientId)}><i className="icon-eye" /></a>
                        </li>
                        <li style={{ cursor: "pointer", marginLeft: "10px" }} className="delete">
                            <a onClick={() => confirmDelete(row.clientId)}><i className="icon-trash" /></a>
                        </li>
                    </ul>
                </div>
            ),
            headerStyle: { width: "5rem", color: "#0000ff" },
        },
        {
            dataField: "factFind",
            text: "Fact Find",
            formatter: (_: any, row: any) => {
                // const isLoading = loading && loadingClientId === row.clientId;
                return (
                    <Button 
                        color="primary" 
                        size="sm"
                        onClick={() => handleDownloadPDF(row)}
                        disabled={loading}
                        className="w-100"
                        style={{ 
                            minHeight: "32px",
                            position: "relative",
                            overflow: "hidden"
                        }}
                    >
                        
                            <div className="d-flex align-items-center justify-content-center">
                                <i className="icon-file-pdf me-1" />
                                <span>{loading ? "Generating . ."  : "PDF"}</span>
                            </div>
                    </Button>
                );
            },
            headerStyle: { width: "6rem", color: "#0000ff", textAlign: "center" },
            style: { textAlign: "center" },
        },
        { dataField: "client1LastName", text: "Surname", headerStyle: { width: "11rem", color: "#0000ff" } },
        {
            dataField: "client1FirstName",
            text: "First Name",
            headerStyle: { width: "11rem", color: "#0000ff", borderRight: "4px solid blue", paddingRight: "10px" },
            style: { borderRight: "4px solid blue", paddingRight: "10px" },
        },
        {
            dataField: "totalIncome",
            text: "Income",
            headerStyle: {
                width: "11rem",
                color: "#0000ff",
                paddingLeft: "30px" // Add space between border and text
            },
            style: { paddingLeft: "30px" },
        },
        { dataField: "totalExpenses", text: "Expense", headerStyle: { width: "11rem", color: "#0000ff" } },
        {
            dataField: "savingsforInvestment",
            text: "Savings",
            headerStyle: { width: "11rem", color: "#0000ff", borderRight: "4px solid blue", paddingRight: "10px" },
            style: { borderRight: "4px solid blue", paddingRight: "10px" },
        },
        {
            dataField: "badDebt",
            text: "Bad Debt",
            headerStyle: {
                width: "11rem",
                color: "#0000ff",
                paddingLeft: "30px" // Add space between border and text
            },
            style: { paddingLeft: "30px" },
        },
        { dataField: "goodDebt", text: "Good Debt", headerStyle: { width: "11rem", color: "#0000ff" } },
        {
            dataField: "netAssets",
            text: "Net Assets",
            headerStyle: { width: "11rem", color: "#0000ff" },
        },
    ];

    return (
        <div className="px-4 pt-4" style={{ minHeight: "500px", boxShadow: "0 4px 8px rgba(0, 0, 0, 0.1)", backgroundColor: "#f9f9f9", borderRadius: "8px" }}>
            <div style={{ borderRadius: "8px", boxShadow: "0 4px 8px rgba(0, 0, 0, 0.1)", padding: "5px", backgroundColor: "#fff" }}>
                <div className="mx-3 py-2">
                    <h3 className="f-w-900 heading-color">Client List</h3>
                </div>
                {isLoading ? (
                    <div style={{ borderRadius: "8px", boxShadow: "0 4px 8px rgba(0, 0, 0, 0.1)", padding: "12px", backgroundColor: "#fff", textAlign: "center" }} className='mt-4 mb-2'>
                        <Spinner color="primary" />
                    </div>
                ) : clients.length !== 0 ? (
                    <div style={{ backgroundColor: "#fff", overflowX: "auto", width: "100%" }} >
                        <div style={{ minWidth: "max-content" }}>
                            <BootstrapTable
                                keyField="clientId"
                                data={clients}
                                columns={clientColumns as any}
                                bordered={false}
                                // rowStyle={rowStyle}
                                wrapperClasses="table-responsive"
                            />
                        </div>
                    </div>
                ) : (
                    <div style={{ borderRadius: "8px", boxShadow: "0 4px 8px rgba(0, 0, 0, 0.1)", padding: "12px", backgroundColor: "#fff", textAlign: "center" }} className='mt-4 mb-2'>
                        <h6>No Client data available.</h6>
                    </div>
                )}
                <Modal isOpen={deleteModal} toggle={() => setDeleteModal(!deleteModal)} centered>
                    <ModalHeader toggle={() => setDeleteModal(!deleteModal)}>Confirm Delete</ModalHeader>
                    <ModalBody>Are you sure you want to delete this client?</ModalBody>
                    <ModalFooter>
                        <Button color="primary" onClick={() => setDeleteModal(false)}>Cancel</Button>
                        <Button color="danger" onClick={handleDeleteClick} disabled={isDeleting}>
                            {isDeleting ? "Deleting..." : "Delete"}
                        </Button>
                    </ModalFooter>
                </Modal>
            </div>
        </div>
    );
};

export default CRMClientList;
